// Armenian -> Latin transliteration for the second (English) line on the member card.
// Simplified ISO 9985 without diacritics; good enough for names, places and titles.
const MAP = {
  ա: "a", բ: "b", գ: "g", դ: "d", ե: "e", զ: "z", է: "e", ը: "y", թ: "t", ժ: "zh",
  ի: "i", լ: "l", խ: "kh", ծ: "ts", կ: "k", հ: "h", ձ: "dz", ղ: "gh", ճ: "ch", մ: "m",
  յ: "y", ն: "n", շ: "sh", ո: "o", չ: "ch", պ: "p", ջ: "j", ռ: "r", ս: "s", վ: "v",
  տ: "t", ր: "r", ց: "ts", ւ: "u", փ: "p", ք: "q", օ: "o", ֆ: "f", և: "ev",
};

const transliterateWord = (word) => {
  const lower = word.toLowerCase();
  let out = "";

  for (let i = 0; i < lower.length; i += 1) {
    const ch = lower[i];

    if (ch === "ո" && lower[i + 1] === "ւ") {
      out += "u"; // "ու" is one sound
      i += 1;
    } else if (ch === "ե" && i === 0) {
      out += "ye"; // word-initial Ե
    } else if (ch === "ո" && i === 0) {
      out += "vo"; // word-initial Ո
    } else {
      out += MAP[ch] ?? ch;
    }
  }

  return out;
};

// "Դավիթ Մանուկյան" -> "Davit Manukyan"
export const transliterate = (text) =>
  String(text ?? "")
    .split(/(\s+)/)
    .map((part) => (/^\s+$/.test(part) || !part ? part : transliterateWord(part)))
    .join("")
    .replace(/(^|[^a-zA-Z])([a-z])/g, (_, sep, letter) => sep + letter.toUpperCase());
